!function (t, e) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = e(require("react"));else if ("function" === typeof define && define.amd) define(["react"], e);else {
    var r = e("object" === typeof exports ? require("react") : t.react);

    for (var n in r) {
      ("object" === typeof exports ? exports : t)[n] = r[n];
    }
  }
}(this, function (t) {
  return function (t) {
    function e(n) {
      if (r[n]) return r[n].exports;
      var a = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(a.exports, a, a.exports, e), a.l = !0, a.exports;
    }

    var r = {};
    return e.m = t, e.c = r, e.d = function (t, r, n) {
      e.o(t, r) || Object.defineProperty(t, r, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, e.n = function (t) {
      var r = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(r, "a", r), r;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "", e(e.s = 8);
  }([function (t, e, r) {
    function n(t, e) {
      if (l(t)) return new Date(t.getTime());
      if ("string" !== typeof t) return new Date(t);
      var r = e || {},
          n = r.additionalDigits;
      n = null == n ? d : Number(n);
      var c = a(t),
          h = o(c.date, n),
          p = h.year,
          m = h.restDateString,
          v = i(m, p);

      if (v) {
        var b,
            y = v.getTime(),
            x = 0;
        if (c.time && (x = u(c.time)), c.timezone) b = s(c.timezone) * g;else {
          var _ = y + x,
              w = new Date(_);

          b = f(w);
          var S = new Date(_);
          S.setDate(w.getDate() + 1);
          var k = f(S) - f(w);
          k > 0 && (b += k);
        }
        return new Date(y + x + b);
      }

      return new Date(t);
    }

    function a(t) {
      var e,
          r = {},
          n = t.split(p);

      if (m.test(n[0]) ? (r.date = null, e = n[0]) : (r.date = n[0], e = n[1]), e) {
        var a = F.exec(e);
        a ? (r.time = e.replace(a[1], ""), r.timezone = a[1]) : r.time = e;
      }

      return r;
    }

    function o(t, e) {
      var r,
          n = b[e],
          a = x[e];

      if (r = y.exec(t) || a.exec(t)) {
        var o = r[1];
        return {
          year: parseInt(o, 10),
          restDateString: t.slice(o.length)
        };
      }

      if (r = v.exec(t) || n.exec(t)) {
        var i = r[1];
        return {
          year: 100 * parseInt(i, 10),
          restDateString: t.slice(i.length)
        };
      }

      return {
        year: null
      };
    }

    function i(t, e) {
      if (null === e) return null;
      var r, n, a, o;
      if (0 === t.length) return n = new Date(0), n.setUTCFullYear(e), n;
      if (r = _.exec(t)) return n = new Date(0), a = parseInt(r[1], 10) - 1, n.setUTCFullYear(e, a), n;

      if (r = w.exec(t)) {
        n = new Date(0);
        var i = parseInt(r[1], 10);
        return n.setUTCFullYear(e, 0, i), n;
      }

      if (r = S.exec(t)) {
        n = new Date(0), a = parseInt(r[1], 10) - 1;
        var u = parseInt(r[2], 10);
        return n.setUTCFullYear(e, a, u), n;
      }

      if (r = k.exec(t)) return o = parseInt(r[1], 10) - 1, c(e, o);

      if (r = D.exec(t)) {
        o = parseInt(r[1], 10) - 1;
        return c(e, o, parseInt(r[2], 10) - 1);
      }

      return null;
    }

    function u(t) {
      var e, r, n;
      if (e = M.exec(t)) return (r = parseFloat(e[1].replace(",", "."))) % 24 * h;
      if (e = A.exec(t)) return r = parseInt(e[1], 10), n = parseFloat(e[2].replace(",", ".")), r % 24 * h + n * g;

      if (e = T.exec(t)) {
        r = parseInt(e[1], 10), n = parseInt(e[2], 10);
        var a = parseFloat(e[3].replace(",", "."));
        return r % 24 * h + n * g + 1e3 * a;
      }

      return null;
    }

    function s(t) {
      var e, r;
      return (e = Y.exec(t)) ? 0 : (e = H.exec(t)) ? (r = 60 * parseInt(e[2], 10), "+" === e[1] ? -r : r) : (e = E.exec(t), e ? (r = 60 * parseInt(e[2], 10) + parseInt(e[3], 10), "+" === e[1] ? -r : r) : 0);
    }

    function c(t, e, r) {
      e = e || 0, r = r || 0;
      var n = new Date(0);
      n.setUTCFullYear(t, 0, 4);
      var a = n.getUTCDay() || 7,
          o = 7 * e + r + 1 - a;
      return n.setUTCDate(n.getUTCDate() + o), n;
    }

    var f = r(16),
        l = r(3),
        h = 36e5,
        g = 6e4,
        d = 2,
        p = /[T ]/,
        m = /:/,
        v = /^(\d{2})$/,
        b = [/^([+-]\d{2})$/, /^([+-]\d{3})$/, /^([+-]\d{4})$/],
        y = /^(\d{4})/,
        x = [/^([+-]\d{4})/, /^([+-]\d{5})/, /^([+-]\d{6})/],
        _ = /^-(\d{2})$/,
        w = /^-?(\d{3})$/,
        S = /^-?(\d{2})-?(\d{2})$/,
        k = /^-?W(\d{2})$/,
        D = /^-?W(\d{2})-?(\d{1})$/,
        M = /^(\d{2}([.,]\d*)?)$/,
        A = /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
        T = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
        F = /([Z+-].*)$/,
        Y = /^(Z)$/,
        H = /^([+-])(\d{2})$/,
        E = /^([+-])(\d{2}):?(\d{2})$/;
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      return a(t, {
        weekStartsOn: 1
      });
    }

    var a = r(21);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r) {
      var n = e ? String(e) : "YYYY-MM-DDTHH:mm:ss.SSSZ",
          o = r || {},
          i = o.locale,
          u = g.format.formatters,
          s = g.format.formattingTokensRegExp;
      i && i.format && i.format.formatters && (u = i.format.formatters, i.format.formattingTokensRegExp && (s = i.format.formattingTokensRegExp));
      var c = l(t);
      return h(c) ? a(n, u, s)(c) : "Invalid Date";
    }

    function a(t, e, r) {
      var n,
          a,
          i = t.match(r),
          u = i.length;

      for (n = 0; n < u; n++) {
        a = e[i[n]] || d[i[n]], i[n] = a || o(i[n]);
      }

      return function (t) {
        for (var e = "", r = 0; r < u; r++) {
          i[r] instanceof Function ? e += i[r](t, d) : e += i[r];
        }

        return e;
      };
    }

    function o(t) {
      return t.match(/\[[\s\S]/) ? t.replace(/^\[|]$/g, "") : t.replace(/\\/g, "");
    }

    function i(t, e) {
      e = e || "";
      var r = t > 0 ? "-" : "+",
          n = Math.abs(t),
          a = Math.floor(n / 60),
          o = n % 60;
      return r + u(a, 2) + e + u(o, 2);
    }

    function u(t, e) {
      for (var r = Math.abs(t).toString(); r.length < e;) {
        r = "0" + r;
      }

      return r;
    }

    var s = r(15),
        c = r(20),
        f = r(4),
        l = r(0),
        h = r(23),
        g = r(24),
        d = {
      M: function M(t) {
        return t.getMonth() + 1;
      },
      MM: function MM(t) {
        return u(t.getMonth() + 1, 2);
      },
      Q: function Q(t) {
        return Math.ceil((t.getMonth() + 1) / 3);
      },
      D: function D(t) {
        return t.getDate();
      },
      DD: function DD(t) {
        return u(t.getDate(), 2);
      },
      DDD: function DDD(t) {
        return s(t);
      },
      DDDD: function DDDD(t) {
        return u(s(t), 3);
      },
      d: function d(t) {
        return t.getDay();
      },
      E: function E(t) {
        return t.getDay() || 7;
      },
      W: function W(t) {
        return c(t);
      },
      WW: function WW(t) {
        return u(c(t), 2);
      },
      YY: function YY(t) {
        return u(t.getFullYear(), 4).substr(2);
      },
      YYYY: function YYYY(t) {
        return u(t.getFullYear(), 4);
      },
      GG: function GG(t) {
        return String(f(t)).substr(2);
      },
      GGGG: function GGGG(t) {
        return f(t);
      },
      H: function H(t) {
        return t.getHours();
      },
      HH: function HH(t) {
        return u(t.getHours(), 2);
      },
      h: function h(t) {
        var e = t.getHours();
        return 0 === e ? 12 : e > 12 ? e % 12 : e;
      },
      hh: function hh(t) {
        return u(d.h(t), 2);
      },
      m: function m(t) {
        return t.getMinutes();
      },
      mm: function mm(t) {
        return u(t.getMinutes(), 2);
      },
      s: function s(t) {
        return t.getSeconds();
      },
      ss: function ss(t) {
        return u(t.getSeconds(), 2);
      },
      S: function S(t) {
        return Math.floor(t.getMilliseconds() / 100);
      },
      SS: function SS(t) {
        return u(Math.floor(t.getMilliseconds() / 10), 2);
      },
      SSS: function SSS(t) {
        return u(t.getMilliseconds(), 3);
      },
      Z: function Z(t) {
        return i(t.getTimezoneOffset(), ":");
      },
      ZZ: function ZZ(t) {
        return i(t.getTimezoneOffset());
      },
      X: function X(t) {
        return Math.floor(t.getTime() / 1e3);
      },
      x: function x(t) {
        return t.getTime();
      }
    };
    t.exports = n;
  }, function (t, e) {
    function r(t) {
      return t instanceof Date;
    }

    t.exports = r;
  }, function (t, e, r) {
    function n(t) {
      var e = a(t),
          r = e.getFullYear(),
          n = new Date(0);
      n.setFullYear(r + 1, 0, 4), n.setHours(0, 0, 0, 0);
      var i = o(n),
          u = new Date(0);
      u.setFullYear(r, 0, 4), u.setHours(0, 0, 0, 0);
      var s = o(u);
      return e.getTime() >= i.getTime() ? r + 1 : e.getTime() >= s.getTime() ? r : r - 1;
    }

    var a = r(0),
        o = r(1);
    t.exports = n;
  }, function (t, e, r) {
    "use strict";

    r.d(e, "a", function () {
      return n;
    }), r.d(e, "d", function () {
      return a;
    }), r.d(e, "b", function () {
      return o;
    }), r.d(e, "c", function () {
      return i;
    }), r.d(e, "e", function () {
      return u;
    });
    var n = {
      background: "transparent",
      text: "#000",
      grade4: "#196127",
      grade3: "#239a3b",
      grade2: "#7bc96f",
      grade1: "#c6e48b",
      grade0: "#ebedf0"
    },
        a = "react-github-calendar",
        o = 1.5,
        i = 2,
        u = 1.25;
  }, function (t, e, r) {
    function n(t, e) {
      var r = a(t),
          n = Number(e);
      return r.setDate(r.getDate() + n), r;
    }

    var a = r(0);
    t.exports = n;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "inherit",
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : o()("white").darken(8).toHslString(),
          n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "transparent",
          a = o()(t);
      return a.isValid() ? {
        background: n,
        text: o()(e).isValid() ? o()(e) : i.a.text,
        grade4: a.setAlpha(.92).toHslString(),
        grade3: a.setAlpha(.76).toHslString(),
        grade2: a.setAlpha(.6).toHslString(),
        grade1: a.setAlpha(.44).toHslString(),
        grade0: r
      } : i.a;
    }

    e.a = n;
    var a = r(42),
        o = r.n(a),
        i = r(5);
  }, function (t, e, r) {
    t.exports = r(9);
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = r(10),
        a = r(7);
    r.d(e, "default", function () {
      return n.a;
    }), r.d(e, "createCalendarTheme", function () {
      return a.a;
    });
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function a(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" !== typeof e && "function" !== typeof e ? t : e;
    }

    function o(t, e) {
      if ("function" !== typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }

    var i = r(11),
        u = r.n(i),
        s = r(12),
        c = r.n(s),
        f = r(2),
        l = r.n(f),
        h = r(28),
        g = r.n(h),
        d = r(5),
        p = r(29),
        m = r(7),
        v = function () {
      function t(t, e) {
        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
        }
      }

      return function (e, r, n) {
        return r && t(e.prototype, r), n && t(e, n), e;
      };
    }(),
        b = function (t) {
      function e() {
        var t, r, o, i;
        n(this, e);

        for (var u = arguments.length, s = Array(u), c = 0; c < u; c++) {
          s[c] = arguments[c];
        }

        return r = o = a(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(s))), o.state = {
          graphs: null,
          error: null
        }, i = r, a(o, i);
      }

      return o(e, t), v(e, [{
        key: "componentDidMount",
        value: function value() {
          var t = this,
              e = this.props,
              r = e.years,
              n = e.username,
              a = e.fullYear;
          Object(p.a)({
            years: r,
            username: n,
            fullYear: a
          }).then(function (e) {
            return t.setState({
              graphs: e
            });
          }).catch(function (e) {
            return t.setState({
              error: e
            });
          });
        }
      }, {
        key: "getTheme",
        value: function value() {
          var t = this.props,
              e = t.color,
              r = t.theme;
          return "string" === typeof e ? Object(m.a)(e) : r ? Object.assign({}, d.a, r) : d.a;
        }
      }, {
        key: "getStyles",
        value: function value() {
          var t = this.props,
              e = t.fontSize;
          return {
            anchor: {
              color: "inherit"
            },
            chart: {
              marginBottom: "1rem"
            },
            calendar: {
              maxWidth: "100%",
              height: "auto",
              marginBottom: "0.25rem",
              backgroundColor: t.theme.background,
              overflow: "visible"
            },
            meta: {
              fontSize: e
            },
            title: {
              marginBottom: "0.5rem",
              paddingBottom: "0.25rem",
              borderBottom: "2px solid " + this.getTheme().grade0,
              fontSize: Math.round(e * d.e) + "px"
            }
          };
        }
      }, {
        key: "getClassNameFor",
        value: function value(t) {
          return d.d + "__" + t;
        }
      }, {
        key: "getDimensions",
        value: function value() {
          var t = this.props,
              e = t.blockMargin,
              r = t.blockSize,
              n = t.fontSize;
          return {
            width: 53 * (r + e) - e,
            height: Math.round(n * d.b) + 7 * (r + e) - e
          };
        }
      }, {
        key: "getTooltipMessage",
        value: function value(t) {
          var e = this.props.dateFormat;
          return "<strong>" + t.info.count + " contributions</strong> on " + l()(t.date, e);
        }
      }, {
        key: "renderTitle",
        value: function value() {
          var t = this.props.username;
          return u.a.createElement("div", {
            className: this.getClassNameFor("title"),
            style: this.getStyles().title
          }, u.a.createElement("a", {
            href: "https://github.com/" + t,
            title: "GitHub profile",
            style: this.getStyles().anchor
          }, "@", t, " on GitHub"));
        }
      }, {
        key: "renderMonthLabels",
        value: function value(t) {
          var e = this,
              r = this.props,
              n = r.blockSize,
              a = r.blockMargin,
              o = r.fontSize;
          return t[1].x - t[0].x <= d.c && t.shift(), t.map(function (t) {
            return u.a.createElement("text", {
              x: (n + a) * t.x,
              y: o,
              key: t.x,
              style: {
                fill: e.getTheme().text,
                fontSize: o
              }
            }, t.label);
          });
        }
      }, {
        key: "renderBlocks",
        value: function value(t) {
          var e = this,
              r = this.props,
              n = r.blockSize,
              a = r.blockMargin,
              o = r.fontSize,
              i = this.getTheme(),
              s = Math.round(o * d.b);
          return t.map(function (t) {
            return t.map(function (t, r) {
              return u.a.createElement("rect", {
                x: "0",
                y: s + (n + a) * r,
                width: n,
                height: n,
                fill: i["grade" + (t.info ? t.info.intensity : 0)],
                "data-tip": t.info && t.info.count ? e.getTooltipMessage(t) : null,
                key: t.date
              });
            });
          }).map(function (t, e) {
            return u.a.createElement("g", {
              key: e,
              transform: "translate(" + (n + a) * e + ", 0)"
            }, t);
          });
        }
      }, {
        key: "renderMeta",
        value: function value(t, e) {
          var r = this.props.fullYear,
              n = g()(new Date()) === t;
          return u.a.createElement("div", {
            className: this.getClassNameFor("meta"),
            style: this.getStyles().meta
          }, n && r ? "Last year" : t, " \u2013 ", n && !r ? "So far " : null, e, " contributions");
        }
      }, {
        key: "render",
        value: function value() {
          var t = this,
              e = this.props,
              r = e.children,
              n = e.style,
              a = this.state,
              o = a.error,
              i = a.graphs,
              s = this.getStyles(),
              c = this.getDimensions(),
              f = c.width,
              l = c.height;
          return o ? u.a.createElement("p", null, "Error :(") : i ? u.a.createElement("article", {
            className: d.d,
            style: n
          }, this.renderTitle(), i.map(function (e, n) {
            var a = e.year,
                o = e.blocks,
                c = e.monthLabels,
                h = e.totalCount;
            return u.a.createElement("div", {
              key: a,
              className: t.getClassNameFor("chart"),
              style: n < i.length - 1 ? s.chart : null
            }, u.a.createElement("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: f,
              height: l,
              viewBox: "0 0 " + f + " " + l,
              textRendering: "optimizeLegibility",
              className: t.getClassNameFor("calendar"),
              style: s.calendar
            }, t.renderMonthLabels(c), t.renderBlocks(o)), t.renderMeta(a, h), r);
          })) : u.a.createElement("div", {
            className: this.getClassNameFor("loading")
          }, "Loading \u2026");
        }
      }]), e;
    }(i.Component);

    b.propTypes = {
      blockSize: c.a.number,
      blockMargin: c.a.number,
      color: c.a.string,
      dateFormat: c.a.string,
      fontSize: c.a.number,
      fullYear: c.a.bool,
      theme: c.a.objectOf(c.a.string),
      tooltips: c.a.bool,
      username: c.a.string.isRequired,
      years: c.a.arrayOf(c.a.number)
    }, b.defaultProps = {
      blockSize: 12,
      blockMargin: 2,
      color: null,
      dateFormat: "MMM D, YYYY",
      fontSize: 14,
      fullYear: !0,
      theme: d.a,
      tooltips: !0,
      years: [Number(l()(new Date(), "YYYY"))]
    }, e.a = b;
  }, function (e, r) {
    e.exports = t;
  }, function (t, e, r) {
    t.exports = r(13)();
  }, function (t, e, r) {
    "use strict";

    function n() {}

    function a() {}

    var o = r(14);
    a.resetWarningCache = n, t.exports = function () {
      function t(t, e, r, n, a, i) {
        if (i !== o) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }

      function e() {
        return t;
      }

      t.isRequired = t;
      var r = {
        array: t,
        bool: t,
        func: t,
        number: t,
        object: t,
        string: t,
        symbol: t,
        any: t,
        arrayOf: e,
        element: t,
        elementType: t,
        instanceOf: e,
        node: t,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: a,
        resetWarningCache: n
      };
      return r.PropTypes = r, r;
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (t, e, r) {
    function n(t) {
      var e = a(t);
      return i(e, o(e)) + 1;
    }

    var a = r(0),
        o = r(17),
        i = r(18);
    t.exports = n;
  }, function (t, e) {
    t.exports = function (t) {
      var e = new Date(t.getTime()),
          r = e.getTimezoneOffset();
      return e.setSeconds(0, 0), 6e4 * r + e.getTime() % 6e4;
    };
  }, function (t, e, r) {
    function n(t) {
      var e = a(t),
          r = new Date(0);
      return r.setFullYear(e.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
    }

    var a = r(0);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e) {
      var r = a(t),
          n = a(e),
          u = r.getTime() - r.getTimezoneOffset() * o,
          s = n.getTime() - n.getTimezoneOffset() * o;
      return Math.round((u - s) / i);
    }

    var a = r(19),
        o = 6e4,
        i = 864e5;
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      var e = a(t);
      return e.setHours(0, 0, 0, 0), e;
    }

    var a = r(0);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      var e = a(t),
          r = o(e).getTime() - i(e).getTime();
      return Math.round(r / u) + 1;
    }

    var a = r(0),
        o = r(1),
        i = r(22),
        u = 6048e5;
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e) {
      var r = e ? Number(e.weekStartsOn) || 0 : 0,
          n = a(t),
          o = n.getDay(),
          i = (o < r ? 7 : 0) + o - r;
      return n.setDate(n.getDate() - i), n.setHours(0, 0, 0, 0), n;
    }

    var a = r(0);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      var e = a(t),
          r = new Date(0);
      return r.setFullYear(e, 0, 4), r.setHours(0, 0, 0, 0), o(r);
    }

    var a = r(4),
        o = r(1);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      if (a(t)) return !isNaN(t);
      throw new TypeError(toString.call(t) + " is not an instance of Date");
    }

    var a = r(3);
    t.exports = n;
  }, function (t, e, r) {
    var n = r(25),
        a = r(26);
    t.exports = {
      distanceInWords: n(),
      format: a()
    };
  }, function (t, e) {
    function r() {
      function t(t, r, n) {
        n = n || {};
        var a;
        return a = "string" === typeof e[t] ? e[t] : 1 === r ? e[t].one : e[t].other.replace("{{count}}", r), n.addSuffix ? n.comparison > 0 ? "in " + a : a + " ago" : a;
      }

      var e = {
        lessThanXSeconds: {
          one: "less than a second",
          other: "less than {{count}} seconds"
        },
        xSeconds: {
          one: "1 second",
          other: "{{count}} seconds"
        },
        halfAMinute: "half a minute",
        lessThanXMinutes: {
          one: "less than a minute",
          other: "less than {{count}} minutes"
        },
        xMinutes: {
          one: "1 minute",
          other: "{{count}} minutes"
        },
        aboutXHours: {
          one: "about 1 hour",
          other: "about {{count}} hours"
        },
        xHours: {
          one: "1 hour",
          other: "{{count}} hours"
        },
        xDays: {
          one: "1 day",
          other: "{{count}} days"
        },
        aboutXMonths: {
          one: "about 1 month",
          other: "about {{count}} months"
        },
        xMonths: {
          one: "1 month",
          other: "{{count}} months"
        },
        aboutXYears: {
          one: "about 1 year",
          other: "about {{count}} years"
        },
        xYears: {
          one: "1 year",
          other: "{{count}} years"
        },
        overXYears: {
          one: "over 1 year",
          other: "over {{count}} years"
        },
        almostXYears: {
          one: "almost 1 year",
          other: "almost {{count}} years"
        }
      };
      return {
        localize: t
      };
    }

    t.exports = r;
  }, function (t, e, r) {
    function n() {
      var t = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          e = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          r = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
          n = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          i = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          u = ["AM", "PM"],
          s = ["am", "pm"],
          c = ["a.m.", "p.m."],
          f = {
        MMM: function MMM(e) {
          return t[e.getMonth()];
        },
        MMMM: function MMMM(t) {
          return e[t.getMonth()];
        },
        dd: function dd(t) {
          return r[t.getDay()];
        },
        ddd: function ddd(t) {
          return n[t.getDay()];
        },
        dddd: function dddd(t) {
          return i[t.getDay()];
        },
        A: function A(t) {
          return t.getHours() / 12 >= 1 ? u[1] : u[0];
        },
        a: function a(t) {
          return t.getHours() / 12 >= 1 ? s[1] : s[0];
        },
        aa: function aa(t) {
          return t.getHours() / 12 >= 1 ? c[1] : c[0];
        }
      };
      return ["M", "D", "DDD", "d", "Q", "W"].forEach(function (t) {
        f[t + "o"] = function (e, r) {
          return a(r[t](e));
        };
      }), {
        formatters: f,
        formattingTokensRegExp: o(f)
      };
    }

    function a(t) {
      var e = t % 100;
      if (e > 20 || e < 10) switch (e % 10) {
        case 1:
          return t + "st";

        case 2:
          return t + "nd";

        case 3:
          return t + "rd";
      }
      return t + "th";
    }

    var o = r(27);
    t.exports = n;
  }, function (t, e) {
    function r(t) {
      var e = [];

      for (var r in t) {
        t.hasOwnProperty(r) && e.push(r);
      }

      var a = n.concat(e).sort().reverse();
      return new RegExp("(\\[[^\\[]*\\])|(\\\\)?(" + a.join("|") + "|.)", "g");
    }

    var n = ["M", "MM", "Q", "D", "DD", "DDD", "DDDD", "d", "E", "W", "WW", "YY", "YYYY", "GG", "GGGG", "H", "HH", "h", "hh", "m", "mm", "s", "ss", "S", "SS", "SSS", "Z", "ZZ", "X", "x"];
    t.exports = r;
  }, function (t, e, r) {
    function n(t) {
      return a(t).getFullYear();
    }

    var a = r(0);
    t.exports = n;
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      return function () {
        var e = t.apply(this, arguments);
        return new Promise(function (t, r) {
          function n(a, o) {
            try {
              var i = e[a](o),
                  u = i.value;
            } catch (t) {
              return void r(t);
            }

            if (!i.done) return Promise.resolve(u).then(function (t) {
              n("next", t);
            }, function (t) {
              n("throw", t);
            });
            t(u);
          }

          return n("next");
        });
      };
    }

    function a(t, e) {
      return t.contributions.find(function (t) {
        return t.date === e;
      });
    }

    function o(t) {
      var e = t.contributions,
          r = new Date(),
          n = e.findIndex(function (t) {
        return t.date === p()(r, Y);
      });
      if (-1 === n) return 0;
      var a = e.findIndex(function (t) {
        return t.date === p()(F()(r, 1), Y);
      });
      return -1 === a && (a = e.length - 1), e.slice(n, a).reduce(function (t, e) {
        return t + e.count;
      }, 0);
    }

    function i(t, e) {
      var r = t.years.find(function (t) {
        return t.year === String(e);
      });
      return r ? r.total : 0;
    }

    function u(t, e, r) {
      var n = new Date(),
          o = r ? F()(n, 1) : D()(t + "-01-01"),
          i = r ? n : D()(t + "-12-31"),
          u = o;
      0 !== v()(o) && (u = g()(o, v()(o)));

      for (var s = []; u <= i;) {
        var c = p()(u, Y);
        s.push({
          date: c,
          info: a(e, c)
        }), u = A()(u, 7);
      }

      return s.map(function (t) {
        for (var r = [], n = 0; n <= 6; n += 1) {
          var o = p()(A()(t.date, n), Y);
          if (_()(o, i)) break;
          r.push({
            date: o,
            info: a(e, o)
          });
        }

        return r;
      });
    }

    function s(t, e) {
      var r = 0,
          n = t.length;
      return t.slice(0, e ? n - 1 : n).reduce(function (t, e, n) {
        var a = D()(e[0].date),
            o = y()(a) + 1,
            i = o !== r,
            u = 0 === n && 12 === o;
        return i && !u && (t.push({
          x: n,
          label: p()(a, "MMM")
        }), r = o), t;
      }, []);
    }

    function c(t, e, r) {
      var n = u(t, e, r);
      return {
        year: t,
        blocks: n,
        monthLabels: s(n, r),
        totalCount: r ? o(e) : i(e, t)
      };
    }

    r.d(e, "a", function () {
      return H;
    });

    var f = r(30),
        l = r.n(f),
        h = r(6),
        g = r.n(h),
        d = r(2),
        p = r.n(d),
        m = r(33),
        v = r.n(m),
        b = r(34),
        y = r.n(b),
        x = r(35),
        _ = r.n(x),
        w = r(36),
        S = r.n(w),
        k = r(0),
        D = r.n(k),
        M = r(37),
        A = r.n(M),
        T = r(38),
        F = r.n(T),
        Y = "YYYY-MM-DD",
        H = function () {
      var t = n(l.a.mark(function t(e) {
        var r, n, a, o;
        return l.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return r = e.years, n = e.fullYear, a = e.username, t.next = 3, fetch("https://grubersjoe-github-contributions-api.now.sh/v1/" + a);

              case 3:
                return t.next = 5, t.sent.json();

              case 5:
                if (o = t.sent, o.years.length) {
                  t.next = 8;
                  break;
                }

                throw new Error("No data available");

              case 8:
                return t.abrupt("return", r.map(function (t) {
                  var e = S()(D()(String(t)), new Date());
                  return c(t, o, e && n);
                }));

              case 9:
              case "end":
                return t.stop();
            }
          }
        }, t, this);
      }));
      return function (e) {
        return t.apply(this, arguments);
      };
    }();
  }, function (t, e, r) {
    t.exports = r(31);
  }, function (t, e, r) {
    var n = function () {
      return this;
    }() || Function("return this")(),
        a = n.regeneratorRuntime && Object.getOwnPropertyNames(n).indexOf("regeneratorRuntime") >= 0,
        o = a && n.regeneratorRuntime;

    if (n.regeneratorRuntime = void 0, t.exports = r(32), a) n.regeneratorRuntime = o;else try {
      delete n.regeneratorRuntime;
    } catch (t) {
      n.regeneratorRuntime = void 0;
    }
  }, function (t, e) {
    !function (e) {
      "use strict";

      function r(t, e, r, n) {
        var o = e && e.prototype instanceof a ? e : a,
            i = Object.create(o.prototype),
            u = new g(n || []);
        return i._invoke = c(t, r, u), i;
      }

      function n(t, e, r) {
        try {
          return {
            type: "normal",
            arg: t.call(e, r)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }

      function a() {}

      function o() {}

      function i() {}

      function u(t) {
        ["next", "throw", "return"].forEach(function (e) {
          t[e] = function (t) {
            return this._invoke(e, t);
          };
        });
      }

      function s(t) {
        function e(r, a, o, i) {
          var u = n(t[r], t, a);

          if ("throw" !== u.type) {
            var s = u.arg,
                c = s.value;
            return c && "object" === typeof c && b.call(c, "__await") ? Promise.resolve(c.__await).then(function (t) {
              e("next", t, o, i);
            }, function (t) {
              e("throw", t, o, i);
            }) : Promise.resolve(c).then(function (t) {
              s.value = t, o(s);
            }, i);
          }

          i(u.arg);
        }

        function r(t, r) {
          function n() {
            return new Promise(function (n, a) {
              e(t, r, n, a);
            });
          }

          return a = a ? a.then(n, n) : n();
        }

        var a;
        this._invoke = r;
      }

      function c(t, e, r) {
        var a = D;
        return function (o, i) {
          if (a === A) throw new Error("Generator is already running");

          if (a === T) {
            if ("throw" === o) throw i;
            return p();
          }

          for (r.method = o, r.arg = i;;) {
            var u = r.delegate;

            if (u) {
              var s = f(u, r);

              if (s) {
                if (s === F) continue;
                return s;
              }
            }

            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if (a === D) throw a = T, r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            a = A;
            var c = n(t, e, r);

            if ("normal" === c.type) {
              if (a = r.done ? T : M, c.arg === F) continue;
              return {
                value: c.arg,
                done: r.done
              };
            }

            "throw" === c.type && (a = T, r.method = "throw", r.arg = c.arg);
          }
        };
      }

      function f(t, e) {
        var r = t.iterator[e.method];

        if (r === m) {
          if (e.delegate = null, "throw" === e.method) {
            if (t.iterator.return && (e.method = "return", e.arg = m, f(t, e), "throw" === e.method)) return F;
            e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return F;
        }

        var a = n(r, t.iterator, e.arg);
        if ("throw" === a.type) return e.method = "throw", e.arg = a.arg, e.delegate = null, F;
        var o = a.arg;
        return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = m), e.delegate = null, F) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, F);
      }

      function l(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }

      function h(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }

      function g(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(l, this), this.reset(!0);
      }

      function d(t) {
        if (t) {
          var e = t[x];
          if (e) return e.call(t);
          if ("function" === typeof t.next) return t;

          if (!isNaN(t.length)) {
            var r = -1,
                n = function e() {
              for (; ++r < t.length;) {
                if (b.call(t, r)) return e.value = t[r], e.done = !1, e;
              }

              return e.value = m, e.done = !0, e;
            };

            return n.next = n;
          }
        }

        return {
          next: p
        };
      }

      function p() {
        return {
          value: m,
          done: !0
        };
      }

      var m,
          v = Object.prototype,
          b = v.hasOwnProperty,
          y = "function" === typeof Symbol ? Symbol : {},
          x = y.iterator || "@@iterator",
          _ = y.asyncIterator || "@@asyncIterator",
          w = y.toStringTag || "@@toStringTag",
          S = "object" === typeof t,
          k = e.regeneratorRuntime;

      if (k) return void (S && (t.exports = k));
      k = e.regeneratorRuntime = S ? t.exports : {}, k.wrap = r;
      var D = "suspendedStart",
          M = "suspendedYield",
          A = "executing",
          T = "completed",
          F = {},
          Y = {};

      Y[x] = function () {
        return this;
      };

      var H = Object.getPrototypeOf,
          E = H && H(H(d([])));
      E && E !== v && b.call(E, x) && (Y = E);
      var O = i.prototype = a.prototype = Object.create(Y);
      o.prototype = O.constructor = i, i.constructor = o, i[w] = o.displayName = "GeneratorFunction", k.isGeneratorFunction = function (t) {
        var e = "function" === typeof t && t.constructor;
        return !!e && (e === o || "GeneratorFunction" === (e.displayName || e.name));
      }, k.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, i) : (t.__proto__ = i, w in t || (t[w] = "GeneratorFunction")), t.prototype = Object.create(O), t;
      }, k.awrap = function (t) {
        return {
          __await: t
        };
      }, u(s.prototype), s.prototype[_] = function () {
        return this;
      }, k.AsyncIterator = s, k.async = function (t, e, n, a) {
        var o = new s(r(t, e, n, a));
        return k.isGeneratorFunction(e) ? o : o.next().then(function (t) {
          return t.done ? t.value : o.next();
        });
      }, u(O), O[w] = "Generator", O[x] = function () {
        return this;
      }, O.toString = function () {
        return "[object Generator]";
      }, k.keys = function (t) {
        var e = [];

        for (var r in t) {
          e.push(r);
        }

        return e.reverse(), function r() {
          for (; e.length;) {
            var n = e.pop();
            if (n in t) return r.value = n, r.done = !1, r;
          }

          return r.done = !0, r;
        };
      }, k.values = d, g.prototype = {
        constructor: g,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = m, this.done = !1, this.delegate = null, this.method = "next", this.arg = m, this.tryEntries.forEach(h), !t) for (var e in this) {
            "t" === e.charAt(0) && b.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = m);
          }
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0],
              e = t.completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          function e(e, n) {
            return o.type = "throw", o.arg = t, r.next = e, n && (r.method = "next", r.arg = m), !!n;
          }

          if (this.done) throw t;

          for (var r = this, n = this.tryEntries.length - 1; n >= 0; --n) {
            var a = this.tryEntries[n],
                o = a.completion;
            if ("root" === a.tryLoc) return e("end");

            if (a.tryLoc <= this.prev) {
              var i = b.call(a, "catchLoc"),
                  u = b.call(a, "finallyLoc");

              if (i && u) {
                if (this.prev < a.catchLoc) return e(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return e(a.finallyLoc);
              } else if (i) {
                if (this.prev < a.catchLoc) return e(a.catchLoc, !0);
              } else {
                if (!u) throw new Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return e(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, e) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var n = this.tryEntries[r];

            if (n.tryLoc <= this.prev && b.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
              var a = n;
              break;
            }
          }

          a && ("break" === t || "continue" === t) && a.tryLoc <= e && e <= a.finallyLoc && (a = null);
          var o = a ? a.completion : {};
          return o.type = t, o.arg = e, a ? (this.method = "next", this.next = a.finallyLoc, F) : this.complete(o);
        },
        complete: function complete(t, e) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), F;
        },
        finish: function finish(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), h(r), F;
          }
        },
        catch: function _catch(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];

            if (r.tryLoc === t) {
              var n = r.completion;

              if ("throw" === n.type) {
                var a = n.arg;
                h(r);
              }

              return a;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, e, r) {
          return this.delegate = {
            iterator: d(t),
            resultName: e,
            nextLoc: r
          }, "next" === this.method && (this.arg = m), F;
        }
      };
    }(function () {
      return this;
    }() || Function("return this")());
  }, function (t, e, r) {
    function n(t) {
      return a(t).getDay();
    }

    var a = r(0);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      return a(t).getMonth();
    }

    var a = r(0);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e) {
      var r = a(t),
          n = a(e);
      return r.getTime() > n.getTime();
    }

    var a = r(0);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e) {
      var r = a(t),
          n = a(e);
      return r.getFullYear() === n.getFullYear();
    }

    var a = r(0);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e, r) {
      var n = r ? Number(r.weekStartsOn) || 0 : 0,
          i = a(t),
          u = Number(e),
          s = i.getDay();
      return o(i, ((u % 7 + 7) % 7 < n ? 7 : 0) + u - s);
    }

    var a = r(0),
        o = r(6);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e) {
      var r = Number(e);
      return a(t, -r);
    }

    var a = r(39);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e) {
      var r = Number(e);
      return a(t, 12 * r);
    }

    var a = r(40);
    t.exports = n;
  }, function (t, e, r) {
    function n(t, e) {
      var r = a(t),
          n = Number(e),
          i = r.getMonth() + n,
          u = new Date(0);
      u.setFullYear(r.getFullYear(), i, 1), u.setHours(0, 0, 0, 0);
      var s = o(u);
      return r.setMonth(i, Math.min(s, r.getDate())), r;
    }

    var a = r(0),
        o = r(41);
    t.exports = n;
  }, function (t, e, r) {
    function n(t) {
      var e = a(t),
          r = e.getFullYear(),
          n = e.getMonth(),
          o = new Date(0);
      return o.setFullYear(r, n + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
    }

    var a = r(0);
    t.exports = n;
  }, function (t, e, r) {
    var n;
    !function (a) {
      function o(t, e) {
        if (t = t || "", e = e || {}, t instanceof o) return t;
        if (!(this instanceof o)) return new o(t, e);
        var r = i(t);
        this._originalInput = t, this._r = r.r, this._g = r.g, this._b = r.b, this._a = r.a, this._roundA = W(100 * this._a) / 100, this._format = e.format || r.format, this._gradientType = e.gradientType, this._r < 1 && (this._r = W(this._r)), this._g < 1 && (this._g = W(this._g)), this._b < 1 && (this._b = W(this._b)), this._ok = r.ok, this._tc_id = $++;
      }

      function i(t) {
        var e = {
          r: 0,
          g: 0,
          b: 0
        },
            r = 1,
            n = null,
            a = null,
            o = null,
            i = !1,
            s = !1;
        return "string" == typeof t && (t = I(t)), "object" == typeof t && (C(t.r) && C(t.g) && C(t.b) ? (e = u(t.r, t.g, t.b), i = !0, s = "%" === String(t.r).substr(-1) ? "prgb" : "rgb") : C(t.h) && C(t.s) && C(t.v) ? (n = L(t.s), a = L(t.v), e = l(t.h, n, a), i = !0, s = "hsv") : C(t.h) && C(t.s) && C(t.l) && (n = L(t.s), o = L(t.l), e = c(t.h, n, o), i = !0, s = "hsl"), t.hasOwnProperty("a") && (r = t.a)), r = T(r), {
          ok: i,
          format: t.format || s,
          r: q(255, U(e.r, 0)),
          g: q(255, U(e.g, 0)),
          b: q(255, U(e.b, 0)),
          a: r
        };
      }

      function u(t, e, r) {
        return {
          r: 255 * F(t, 255),
          g: 255 * F(e, 255),
          b: 255 * F(r, 255)
        };
      }

      function s(t, e, r) {
        t = F(t, 255), e = F(e, 255), r = F(r, 255);
        var n,
            a,
            o = U(t, e, r),
            i = q(t, e, r),
            u = (o + i) / 2;
        if (o == i) n = a = 0;else {
          var s = o - i;

          switch (a = u > .5 ? s / (2 - o - i) : s / (o + i), o) {
            case t:
              n = (e - r) / s + (e < r ? 6 : 0);
              break;

            case e:
              n = (r - t) / s + 2;
              break;

            case r:
              n = (t - e) / s + 4;
          }

          n /= 6;
        }
        return {
          h: n,
          s: a,
          l: u
        };
      }

      function c(t, e, r) {
        function n(t, e, r) {
          return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t + 6 * (e - t) * r : r < .5 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t;
        }

        var a, o, i;
        if (t = F(t, 360), e = F(e, 100), r = F(r, 100), 0 === e) a = o = i = r;else {
          var u = r < .5 ? r * (1 + e) : r + e - r * e,
              s = 2 * r - u;
          a = n(s, u, t + 1 / 3), o = n(s, u, t), i = n(s, u, t - 1 / 3);
        }
        return {
          r: 255 * a,
          g: 255 * o,
          b: 255 * i
        };
      }

      function f(t, e, r) {
        t = F(t, 255), e = F(e, 255), r = F(r, 255);
        var n,
            a,
            o = U(t, e, r),
            i = q(t, e, r),
            u = o,
            s = o - i;
        if (a = 0 === o ? 0 : s / o, o == i) n = 0;else {
          switch (o) {
            case t:
              n = (e - r) / s + (e < r ? 6 : 0);
              break;

            case e:
              n = (r - t) / s + 2;
              break;

            case r:
              n = (t - e) / s + 4;
          }

          n /= 6;
        }
        return {
          h: n,
          s: a,
          v: u
        };
      }

      function l(t, e, r) {
        t = 6 * F(t, 360), e = F(e, 100), r = F(r, 100);
        var n = a.floor(t),
            o = t - n,
            i = r * (1 - e),
            u = r * (1 - o * e),
            s = r * (1 - (1 - o) * e),
            c = n % 6;
        return {
          r: 255 * [r, u, i, i, s, r][c],
          g: 255 * [s, r, r, u, i, i][c],
          b: 255 * [i, i, s, r, r, u][c]
        };
      }

      function h(t, e, r, n) {
        var a = [R(W(t).toString(16)), R(W(e).toString(16)), R(W(r).toString(16))];
        return n && a[0].charAt(0) == a[0].charAt(1) && a[1].charAt(0) == a[1].charAt(1) && a[2].charAt(0) == a[2].charAt(1) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) : a.join("");
      }

      function g(t, e, r, n, a) {
        var o = [R(W(t).toString(16)), R(W(e).toString(16)), R(W(r).toString(16)), R(N(n))];
        return a && o[0].charAt(0) == o[0].charAt(1) && o[1].charAt(0) == o[1].charAt(1) && o[2].charAt(0) == o[2].charAt(1) && o[3].charAt(0) == o[3].charAt(1) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) + o[3].charAt(0) : o.join("");
      }

      function d(t, e, r, n) {
        return [R(N(n)), R(W(t).toString(16)), R(W(e).toString(16)), R(W(r).toString(16))].join("");
      }

      function p(t, e) {
        e = 0 === e ? 0 : e || 10;
        var r = o(t).toHsl();
        return r.s -= e / 100, r.s = Y(r.s), o(r);
      }

      function m(t, e) {
        e = 0 === e ? 0 : e || 10;
        var r = o(t).toHsl();
        return r.s += e / 100, r.s = Y(r.s), o(r);
      }

      function v(t) {
        return o(t).desaturate(100);
      }

      function b(t, e) {
        e = 0 === e ? 0 : e || 10;
        var r = o(t).toHsl();
        return r.l += e / 100, r.l = Y(r.l), o(r);
      }

      function y(t, e) {
        e = 0 === e ? 0 : e || 10;
        var r = o(t).toRgb();
        return r.r = U(0, q(255, r.r - W(-e / 100 * 255))), r.g = U(0, q(255, r.g - W(-e / 100 * 255))), r.b = U(0, q(255, r.b - W(-e / 100 * 255))), o(r);
      }

      function x(t, e) {
        e = 0 === e ? 0 : e || 10;
        var r = o(t).toHsl();
        return r.l -= e / 100, r.l = Y(r.l), o(r);
      }

      function _(t, e) {
        var r = o(t).toHsl(),
            n = (r.h + e) % 360;
        return r.h = n < 0 ? 360 + n : n, o(r);
      }

      function w(t) {
        var e = o(t).toHsl();
        return e.h = (e.h + 180) % 360, o(e);
      }

      function S(t) {
        var e = o(t).toHsl(),
            r = e.h;
        return [o(t), o({
          h: (r + 120) % 360,
          s: e.s,
          l: e.l
        }), o({
          h: (r + 240) % 360,
          s: e.s,
          l: e.l
        })];
      }

      function k(t) {
        var e = o(t).toHsl(),
            r = e.h;
        return [o(t), o({
          h: (r + 90) % 360,
          s: e.s,
          l: e.l
        }), o({
          h: (r + 180) % 360,
          s: e.s,
          l: e.l
        }), o({
          h: (r + 270) % 360,
          s: e.s,
          l: e.l
        })];
      }

      function D(t) {
        var e = o(t).toHsl(),
            r = e.h;
        return [o(t), o({
          h: (r + 72) % 360,
          s: e.s,
          l: e.l
        }), o({
          h: (r + 216) % 360,
          s: e.s,
          l: e.l
        })];
      }

      function M(t, e, r) {
        e = e || 6, r = r || 30;
        var n = o(t).toHsl(),
            a = 360 / r,
            i = [o(t)];

        for (n.h = (n.h - (a * e >> 1) + 720) % 360; --e;) {
          n.h = (n.h + a) % 360, i.push(o(n));
        }

        return i;
      }

      function A(t, e) {
        e = e || 6;

        for (var r = o(t).toHsv(), n = r.h, a = r.s, i = r.v, u = [], s = 1 / e; e--;) {
          u.push(o({
            h: n,
            s: a,
            v: i
          })), i = (i + s) % 1;
        }

        return u;
      }

      function T(t) {
        return t = parseFloat(t), (isNaN(t) || t < 0 || t > 1) && (t = 1), t;
      }

      function F(t, e) {
        E(t) && (t = "100%");
        var r = O(t);
        return t = q(e, U(0, parseFloat(t))), r && (t = parseInt(t * e, 10) / 100), a.abs(t - e) < 1e-6 ? 1 : t % e / parseFloat(e);
      }

      function Y(t) {
        return q(1, U(0, t));
      }

      function H(t) {
        return parseInt(t, 16);
      }

      function E(t) {
        return "string" == typeof t && -1 != t.indexOf(".") && 1 === parseFloat(t);
      }

      function O(t) {
        return "string" === typeof t && -1 != t.indexOf("%");
      }

      function R(t) {
        return 1 == t.length ? "0" + t : "" + t;
      }

      function L(t) {
        return t <= 1 && (t = 100 * t + "%"), t;
      }

      function N(t) {
        return a.round(255 * parseFloat(t)).toString(16);
      }

      function j(t) {
        return H(t) / 255;
      }

      function C(t) {
        return !!J.CSS_UNIT.exec(t);
      }

      function I(t) {
        t = t.replace(z, "").replace(G, "").toLowerCase();
        var e = !1;
        if (X[t]) t = X[t], e = !0;else if ("transparent" == t) return {
          r: 0,
          g: 0,
          b: 0,
          a: 0,
          format: "name"
        };
        var r;
        return (r = J.rgb.exec(t)) ? {
          r: r[1],
          g: r[2],
          b: r[3]
        } : (r = J.rgba.exec(t)) ? {
          r: r[1],
          g: r[2],
          b: r[3],
          a: r[4]
        } : (r = J.hsl.exec(t)) ? {
          h: r[1],
          s: r[2],
          l: r[3]
        } : (r = J.hsla.exec(t)) ? {
          h: r[1],
          s: r[2],
          l: r[3],
          a: r[4]
        } : (r = J.hsv.exec(t)) ? {
          h: r[1],
          s: r[2],
          v: r[3]
        } : (r = J.hsva.exec(t)) ? {
          h: r[1],
          s: r[2],
          v: r[3],
          a: r[4]
        } : (r = J.hex8.exec(t)) ? {
          r: H(r[1]),
          g: H(r[2]),
          b: H(r[3]),
          a: j(r[4]),
          format: e ? "name" : "hex8"
        } : (r = J.hex6.exec(t)) ? {
          r: H(r[1]),
          g: H(r[2]),
          b: H(r[3]),
          format: e ? "name" : "hex"
        } : (r = J.hex4.exec(t)) ? {
          r: H(r[1] + "" + r[1]),
          g: H(r[2] + "" + r[2]),
          b: H(r[3] + "" + r[3]),
          a: j(r[4] + "" + r[4]),
          format: e ? "name" : "hex8"
        } : !!(r = J.hex3.exec(t)) && {
          r: H(r[1] + "" + r[1]),
          g: H(r[2] + "" + r[2]),
          b: H(r[3] + "" + r[3]),
          format: e ? "name" : "hex"
        };
      }

      function P(t) {
        var e, r;
        return t = t || {
          level: "AA",
          size: "small"
        }, e = (t.level || "AA").toUpperCase(), r = (t.size || "small").toLowerCase(), "AA" !== e && "AAA" !== e && (e = "AA"), "small" !== r && "large" !== r && (r = "small"), {
          level: e,
          size: r
        };
      }

      var z = /^\s+/,
          G = /\s+$/,
          $ = 0,
          W = a.round,
          q = a.min,
          U = a.max,
          B = a.random;
      o.prototype = {
        isDark: function isDark() {
          return this.getBrightness() < 128;
        },
        isLight: function isLight() {
          return !this.isDark();
        },
        isValid: function isValid() {
          return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
          return this._originalInput;
        },
        getFormat: function getFormat() {
          return this._format;
        },
        getAlpha: function getAlpha() {
          return this._a;
        },
        getBrightness: function getBrightness() {
          var t = this.toRgb();
          return (299 * t.r + 587 * t.g + 114 * t.b) / 1e3;
        },
        getLuminance: function getLuminance() {
          var t,
              e,
              r,
              n,
              o,
              i,
              u = this.toRgb();
          return t = u.r / 255, e = u.g / 255, r = u.b / 255, n = t <= .03928 ? t / 12.92 : a.pow((t + .055) / 1.055, 2.4), o = e <= .03928 ? e / 12.92 : a.pow((e + .055) / 1.055, 2.4), i = r <= .03928 ? r / 12.92 : a.pow((r + .055) / 1.055, 2.4), .2126 * n + .7152 * o + .0722 * i;
        },
        setAlpha: function setAlpha(t) {
          return this._a = T(t), this._roundA = W(100 * this._a) / 100, this;
        },
        toHsv: function toHsv() {
          var t = f(this._r, this._g, this._b);
          return {
            h: 360 * t.h,
            s: t.s,
            v: t.v,
            a: this._a
          };
        },
        toHsvString: function toHsvString() {
          var t = f(this._r, this._g, this._b),
              e = W(360 * t.h),
              r = W(100 * t.s),
              n = W(100 * t.v);
          return 1 == this._a ? "hsv(" + e + ", " + r + "%, " + n + "%)" : "hsva(" + e + ", " + r + "%, " + n + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
          var t = s(this._r, this._g, this._b);
          return {
            h: 360 * t.h,
            s: t.s,
            l: t.l,
            a: this._a
          };
        },
        toHslString: function toHslString() {
          var t = s(this._r, this._g, this._b),
              e = W(360 * t.h),
              r = W(100 * t.s),
              n = W(100 * t.l);
          return 1 == this._a ? "hsl(" + e + ", " + r + "%, " + n + "%)" : "hsla(" + e + ", " + r + "%, " + n + "%, " + this._roundA + ")";
        },
        toHex: function toHex(t) {
          return h(this._r, this._g, this._b, t);
        },
        toHexString: function toHexString(t) {
          return "#" + this.toHex(t);
        },
        toHex8: function toHex8(t) {
          return g(this._r, this._g, this._b, this._a, t);
        },
        toHex8String: function toHex8String(t) {
          return "#" + this.toHex8(t);
        },
        toRgb: function toRgb() {
          return {
            r: W(this._r),
            g: W(this._g),
            b: W(this._b),
            a: this._a
          };
        },
        toRgbString: function toRgbString() {
          return 1 == this._a ? "rgb(" + W(this._r) + ", " + W(this._g) + ", " + W(this._b) + ")" : "rgba(" + W(this._r) + ", " + W(this._g) + ", " + W(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
          return {
            r: W(100 * F(this._r, 255)) + "%",
            g: W(100 * F(this._g, 255)) + "%",
            b: W(100 * F(this._b, 255)) + "%",
            a: this._a
          };
        },
        toPercentageRgbString: function toPercentageRgbString() {
          return 1 == this._a ? "rgb(" + W(100 * F(this._r, 255)) + "%, " + W(100 * F(this._g, 255)) + "%, " + W(100 * F(this._b, 255)) + "%)" : "rgba(" + W(100 * F(this._r, 255)) + "%, " + W(100 * F(this._g, 255)) + "%, " + W(100 * F(this._b, 255)) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
          return 0 === this._a ? "transparent" : !(this._a < 1) && (Z[h(this._r, this._g, this._b, !0)] || !1);
        },
        toFilter: function toFilter(t) {
          var e = "#" + d(this._r, this._g, this._b, this._a),
              r = e,
              n = this._gradientType ? "GradientType = 1, " : "";

          if (t) {
            var a = o(t);
            r = "#" + d(a._r, a._g, a._b, a._a);
          }

          return "progid:DXImageTransform.Microsoft.gradient(" + n + "startColorstr=" + e + ",endColorstr=" + r + ")";
        },
        toString: function toString(t) {
          var e = !!t;
          t = t || this._format;
          var r = !1,
              n = this._a < 1 && this._a >= 0;
          return e || !n || "hex" !== t && "hex6" !== t && "hex3" !== t && "hex4" !== t && "hex8" !== t && "name" !== t ? ("rgb" === t && (r = this.toRgbString()), "prgb" === t && (r = this.toPercentageRgbString()), "hex" !== t && "hex6" !== t || (r = this.toHexString()), "hex3" === t && (r = this.toHexString(!0)), "hex4" === t && (r = this.toHex8String(!0)), "hex8" === t && (r = this.toHex8String()), "name" === t && (r = this.toName()), "hsl" === t && (r = this.toHslString()), "hsv" === t && (r = this.toHsvString()), r || this.toHexString()) : "name" === t && 0 === this._a ? this.toName() : this.toRgbString();
        },
        clone: function clone() {
          return o(this.toString());
        },
        _applyModification: function _applyModification(t, e) {
          var r = t.apply(null, [this].concat([].slice.call(e)));
          return this._r = r._r, this._g = r._g, this._b = r._b, this.setAlpha(r._a), this;
        },
        lighten: function lighten() {
          return this._applyModification(b, arguments);
        },
        brighten: function brighten() {
          return this._applyModification(y, arguments);
        },
        darken: function darken() {
          return this._applyModification(x, arguments);
        },
        desaturate: function desaturate() {
          return this._applyModification(p, arguments);
        },
        saturate: function saturate() {
          return this._applyModification(m, arguments);
        },
        greyscale: function greyscale() {
          return this._applyModification(v, arguments);
        },
        spin: function spin() {
          return this._applyModification(_, arguments);
        },
        _applyCombination: function _applyCombination(t, e) {
          return t.apply(null, [this].concat([].slice.call(e)));
        },
        analogous: function analogous() {
          return this._applyCombination(M, arguments);
        },
        complement: function complement() {
          return this._applyCombination(w, arguments);
        },
        monochromatic: function monochromatic() {
          return this._applyCombination(A, arguments);
        },
        splitcomplement: function splitcomplement() {
          return this._applyCombination(D, arguments);
        },
        triad: function triad() {
          return this._applyCombination(S, arguments);
        },
        tetrad: function tetrad() {
          return this._applyCombination(k, arguments);
        }
      }, o.fromRatio = function (t, e) {
        if ("object" == typeof t) {
          var r = {};

          for (var n in t) {
            t.hasOwnProperty(n) && (r[n] = "a" === n ? t[n] : L(t[n]));
          }

          t = r;
        }

        return o(t, e);
      }, o.equals = function (t, e) {
        return !(!t || !e) && o(t).toRgbString() == o(e).toRgbString();
      }, o.random = function () {
        return o.fromRatio({
          r: B(),
          g: B(),
          b: B()
        });
      }, o.mix = function (t, e, r) {
        r = 0 === r ? 0 : r || 50;
        var n = o(t).toRgb(),
            a = o(e).toRgb(),
            i = r / 100;
        return o({
          r: (a.r - n.r) * i + n.r,
          g: (a.g - n.g) * i + n.g,
          b: (a.b - n.b) * i + n.b,
          a: (a.a - n.a) * i + n.a
        });
      }, o.readability = function (t, e) {
        var r = o(t),
            n = o(e);
        return (a.max(r.getLuminance(), n.getLuminance()) + .05) / (a.min(r.getLuminance(), n.getLuminance()) + .05);
      }, o.isReadable = function (t, e, r) {
        var n,
            a,
            i = o.readability(t, e);

        switch (a = !1, n = P(r), n.level + n.size) {
          case "AAsmall":
          case "AAAlarge":
            a = i >= 4.5;
            break;

          case "AAlarge":
            a = i >= 3;
            break;

          case "AAAsmall":
            a = i >= 7;
        }

        return a;
      }, o.mostReadable = function (t, e, r) {
        var n,
            a,
            i,
            u,
            s = null,
            c = 0;
        r = r || {}, a = r.includeFallbackColors, i = r.level, u = r.size;

        for (var f = 0; f < e.length; f++) {
          (n = o.readability(t, e[f])) > c && (c = n, s = o(e[f]));
        }

        return o.isReadable(t, s, {
          level: i,
          size: u
        }) || !a ? s : (r.includeFallbackColors = !1, o.mostReadable(t, ["#fff", "#000"], r));
      };

      var X = o.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
      },
          Z = o.hexNames = function (t) {
        var e = {};

        for (var r in t) {
          t.hasOwnProperty(r) && (e[t[r]] = r);
        }

        return e;
      }(X),
          J = function () {
        var t = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)",
            e = "[\\s|\\(]+(" + t + ")[,|\\s]+(" + t + ")[,|\\s]+(" + t + ")\\s*\\)?",
            r = "[\\s|\\(]+(" + t + ")[,|\\s]+(" + t + ")[,|\\s]+(" + t + ")[,|\\s]+(" + t + ")\\s*\\)?";
        return {
          CSS_UNIT: new RegExp(t),
          rgb: new RegExp("rgb" + e),
          rgba: new RegExp("rgba" + r),
          hsl: new RegExp("hsl" + e),
          hsla: new RegExp("hsla" + r),
          hsv: new RegExp("hsv" + e),
          hsva: new RegExp("hsva" + r),
          hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
          hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
      }();

      "undefined" !== typeof t && t.exports ? t.exports = o : void 0 !== (n = function () {
        return o;
      }.call(e, r, e, t)) && (t.exports = n);
    }(Math);
  }]);
});